import React, { useEffect, useState } from "react";
import { useTrail, animated } from "react-spring";
import {
  Button,
  Flex,
  Tooltip,
  Popconfirm,
  message,
  Modal,
  Form,
  Input,
} from "antd";
import { RestaurantService } from "deliziora-client-module/client-web";
import ThreeDots from "../../Images/ThreeDots2.svg";
import "./ListRestaurants.css";
import { useNavigate } from "react-router-dom";
import UploadImagesButton from "../UploadImagesButton/UploadImagesButton";
export default function ListRestaurants() {
  const [image, setImage] = useState("");
  const [images, setImages] = useState("");
  const [fileList, setFileList] = useState([]);
  const [restaurants, setRestaurants] = useState([]);
  const [modalEdit, setModalEdit] = useState(false);

  const [modalDelete, setModalDelete] = useState(false);
  const [selectedRestaurant, setSelectedRestaurant] = useState({});
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  };
  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        const allRestaurantsResponse =
          await RestaurantService.returnAllRestaurantsSlim();
        const { data } = allRestaurantsResponse;
        setRestaurants(data.slice(0, 100)); // Limit to 100 restaurants for performance
      } catch (error) {
        console.error(error);
      }
    };
    fetchRestaurants();
  }, []);
  const trail = useTrail(restaurants.length, {
    opacity: 1,
    transform:
      "perspective(600px) rotateX(0deg) rotateY(0deg) translate3d(0, 0, 0)",
    duration: 1000,
    from: {
      opacity: 0,
      transform:
        "perspective(600px) rotateX(90deg) rotateY(90deg) translate3d(0, -50px, 0)",
    },
    config: { tension: 400, friction: 25 },
  });
  const handleDataReceivedImages = (values) => {
    setImage(values);
  };
  const edit = (e) => {
    console.log(e);
    setSelectedRestaurant(e);
    setImage(e.img);
    setModalEdit(true);
    form.setFieldsValue(e);
  };
  const deleteRestaurant = (e) => {
    console.log(e);
    RestaurantService.deleteRestaurantById(e._id.$oid)
      .then(() => {
        message.success("Apagado com sucesso");
        RestaurantService.returnAllRestaurantsSlim().then((res) => {
          setRestaurants(res.data);
        });
      })
      .catch(() => {
        message.error("Erro ao apagar");
      });
  };
  const onFinish = (values) => {
    console.log(values);
    RestaurantService.updateRestaurantById({
      id_restaurant: values._id.$oid,
      name: values.name,
      address: values.address,
      latitude: selectedRestaurant.latitude,
      especialty: selectedRestaurant.especialty,
      complete_menu: selectedRestaurant.complete_menu,
      email: values.email,
      opening_hours: selectedRestaurant.opening_hours,
      longitude: selectedRestaurant.longitude,
      contact: values.contact,
      description: values.description,
      img: image,
      categories: selectedRestaurant.categories,
      characteristics: selectedRestaurant.characteristics,
      updated_at: "",
      afternoonOpen: selectedRestaurant.afternoonOpen,
      closedForHolidays: selectedRestaurant.closedForHolidays,
      dayClosed: selectedRestaurant.dayClosed,
      isOpen: selectedRestaurant.isOpen,
    })
      .then((res) => {
        console.log(res.data);
        message.success("Dados actualizados com sucesso!");
        RestaurantService.returnAllRestaurantsSlim().then((res) => {
          setRestaurants(res.data);
        });
      })
      .catch((err) => console.log(err));
  };

  const onFinishFailed = (errorInfo) => {
    message.error("Falha no envio do formulário:", errorInfo);
  };
  return (
    <>
      {trail.map((animatedProps, index) => (
        <animated.div
          key={index}
          style={animatedProps}
          className="animated-restaurant"
        >
          <Flex
            horizontal
            align="center"
            justify="space-between"
            style={{
              boxShadow: "1px 1px 3px 1px rgba(0, 0, 0, 0.245)",
              padding: "2rem",
              margin: 10,
              borderRadius: 15,
              gap: "1vw",
              width: window.innerWidth > 1000 ? "30vw" : "90vw",
            }}
          >
            <img
              src={restaurants[index].img}
              style={{
                width: 100,
                height: 100,
                objectFit: "cover",
                borderRadius: 100,
              }}
              alt="restaurant"
            />
            <div>{restaurants[index].name}</div>
            <button
              onClick={() => {
                localStorage.setItem(
                  "userData",
                  JSON.stringify(restaurants[index])
                );
                navigate("/home");
                window.location.reload();
              }}
              style={{
                backgroundColor: "black",
                color: "white",
                paddingLeft: "2rem",
                paddingRight: "2rem",
                paddingTop: ".7rem",
                paddingBottom: ".7rem",
                borderRadius: 50,
              }}
            >
              Ver
            </button>
            <Popconfirm
              onConfirm={() => edit(restaurants[index])}
              onCancel={() => deleteRestaurant(restaurants[index])}
              okText={<div>Editar</div>}
              cancelText={<div>Apagar</div>}
              icon={() => <div></div>}
            >
              <div
                className="threeDots_button"
                style={{
                  position: "absolute",
                  right: "12%",
                  top: "9%",
                  cursor: "pointer",
                }}
              >
                <img src={ThreeDots} alt={`Three dots for item ${index + 1}`} />
              </div>
            </Popconfirm>
          </Flex>
        </animated.div>
      ))}
      <Modal
        open={modalEdit}
        onCancel={() => {
          form.resetFields();
          setModalEdit(false);
        }}
        onOk={() => {
          form.submit();
          setModalEdit(false);
        }}
        okText="Salvar Modificações"
        cancelText="Cancelar"
      >
        <Flex align="center" justify="center" vertical={isMobile()}>
          <img
            src={image}
            alt={image}
            style={{
              borderRadius: "2%",
              width: isMobile() ? "75vw" : "50%",
              height: isMobile() ? "300px" : "50%",
              objectFit: "cover",
            }}
          />
          <UploadImagesButton
            onDataReceived={handleDataReceivedImages}
            setImagesList={setImages}
            fileList={fileList}
            setFileList={setFileList}
          />
        </Flex>

        <Form
          form={form}
          name="form"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
          labelAlign="left"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "90%",
            justifyContent: "space-between",
            padding: "1rem",
          }}
        >
          <Form.Item label="Id" name={["_id", "$oid"]} hidden>
            <Input />
          </Form.Item>
          <Form.Item
            name="name"
            label="Nome"
            rules={[{ required: true, message: "Por favor, insira o nome." }]}
          >
            <Input
              type="text"
              placeholder="Restaurante"
              className="input-form-profile"
            />
          </Form.Item>
          <Form.Item
            name="address"
            label="Endereço Completo"
            style={{ width: "100%" }}
            rules={[
              { required: true, message: "Por favor, insira o endereço." },
            ]}
          >
            <Input placeholder="Avenida Luísa Todi N° 0 , 0000-000 Setúbal" />
          </Form.Item>
          <Form.Item
            name="contact"
            label="Telefone"
            style={{ width: "50%" }}
            rules={[
              { required: true, message: "Por favor, insira o telefone 1." },
            ]}
          >
            <Input
              type="tel"
              placeholder="123 456 789"
              className="input-form-profile-minify"
            />
          </Form.Item>
          <Form.Item
            name="email"
            label="Endereço de Email"
            rules={[
              {
                required: true,
                message: "Por favor, insira o endereço de email.",
              },
              { type: "email", message: "Endereço de email inválido." },
            ]}
          >
            <Input
              type="email"
              placeholder="restaurante@email.pt"
              className="input-form-profile"
            />
          </Form.Item>
          <Form.Item
            name="description"
            label="Descrição"
            rules={[
              {
                required: true,
                message: "Por favor, insira a descrição do restaurante.",
              },
            ]}
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
